import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { PageMeta } from '../../components/meta/PageMeta';
import { TabItem, TabsComponent } from '../../components/tabs/TabsComponent';
import { useGetQuestionsQuery } from '../../services/endpoints/content/questions';
import { question } from '../../types/questions.type';
import { FAQAbout } from './components/faqAbout/FAQAbout';
import { FAQAccordion } from './components/faqAccordion/FAQAccordion';
import { FAQBanner } from './components/faqBanner/FAQBanner';
import { ClassCards } from './components/shopClassCards/ShopClassCards';

const FAQ_TABS = ['in_person', 'online'] as const;
type FaqTab = (typeof FAQ_TABS)[number];

export const FAQsPage = () => {
  const [activeTab, setActiveTab] = useState<FaqTab>('in_person');
  const [activeAccordionKey, setActiveAccordionKey] = useState<string | null>(null);

  const { data, isLoading, isFetching } = useGetQuestionsQuery({
    scope: activeTab,
    data: {
      page: 1,
      entries: 100,
      orderBy: { field: 'id', order: 'asc' }
    }
  });

  const questions: question[] = (data?.results ?? []).filter(
    (q: question) => q.question_type === activeTab
  );

  useEffect(() => {
    setActiveAccordionKey(null);
  }, [activeTab]);

  const handleTabSelect = (tabKey: string) => {
    if (FAQ_TABS.includes(tabKey as FaqTab)) {
      setActiveTab(tabKey as FaqTab);
    }
  };

  const handleAccordionSelect = (eventKey: string | null) => {
    setActiveAccordionKey(eventKey);
  };

  const tabs: TabItem[] = [
    { key: 'in_person', title: 'IN-PERSON PROGRAMS (SCHOOLS/CAMPS)' },
    { key: 'online', title: 'ONLINE CLASSES & CAMPS' }
  ];

  return (
    <div className="faqs-page">
      <PageMeta
        title="FAQs - Cooking Class for Kids"
        description="Get answers to frequently asked questions about online cooking classes for kids, cooking camps, in-person school programs, and private cooking events."
      />
      <FAQBanner />
      <Container className="pt-5">
        <Row>
          <Col lg={12}>
            <TabsComponent
              tabs={tabs}
              activeTab={activeTab}
              onTabSelect={handleTabSelect}
            />
          </Col>
        </Row>

        <Row className="mt-4">
          <Col lg={12}>
            <div className="faqs-accordion-container">
              <FAQAccordion
                questions={questions}
                isLoading={isLoading || isFetching}
                activeKey={activeAccordionKey}
                onSelect={handleAccordionSelect}
              />
            </div>
          </Col>
        </Row>
      </Container>
      <FAQAbout />
      <ClassCards />
    </div>
  );
};
